import { Injectable } from '@angular/core';
import {OpenGraphData, OpenGraphImageInfo} from "./model/OpenGraphData";
declare let iNet: any;
declare let $: any;

@Injectable()
export class OpenGraphService {

  private regex = /(https?:\/\/[^\s]+)/;

  constructor() { }

  loadPreviewLink(link: string, callback: Function) {
    if (link==null) {
      callback(null, {
        error: 'Link is empty'
      });
      return;
    }
    if (!this.isLink(link)) {
      callback(null, {
        error: 'Link invalid'
      });
      return;
    }

    $.ajax({
      type: 'post',
      url: iNet.getUrl('opengraph/fetch'),
      data: {
       url: link
      },
      success: (data: any) => {
         callback(this.convertOpenData(data, link));
      },
      error: function (xhr: any) {
        callback(null, xhr);
      }
    });
  }

  isLink(link: string): boolean {
    return this.regex.test(link);
  }

  loadImageInfo(src: string, callback: Function) {
    let img = new Image();
    img.onload = img.onerror = function (e) {
      let imageInfo: OpenGraphImageInfo = {
        width: img.width,
        height: img.height
      };
      if (imageInfo.width && imageInfo.height) {
        imageInfo.available = true;
        imageInfo.landscape = imageInfo.width / imageInfo.height > 1.1;
      }
      callback(imageInfo);
    };
    img.src = src;
  }

  private convertOpenData(properties: any[], url: string): OpenGraphData | undefined {
    if (properties.length < 1) {
      return;
    }
    let openData: any = <OpenGraphData>{};

    properties.forEach((item: any) => {
      openData[item.property] = item.content;
    });

    if (!openData.url) {
      openData.url = url;
    }

    return openData;
  }
}
